import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
  .form-title {
      font-size: 1.1em;
      color: #ffffff;
      margin-bottom: 1em;
      font-weight: 700;
  }

  .form-inputs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .layout-forms-input {
      &:not(:last-child) {
        margin-right: 1em;
      }
    }
    .layout-forms-input-wrapper {
      margin-bottom: 0;

      .label-wrapper {
        display: none;
      }
    }

    .layout-button {
      width: 10em;

      .button {
        width: 100%;

        .button-icon-before {
          flex-shrink: .1;
        }
      }
    }
  }

  .button-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 2em;

    .layout-button {
      margin-right: 2em;

      .button {
        border-radius: 5em;
        border: .1em solid #10F5B0;
        background-color: #000;
        color: #fff;
        font-weight: 300;
        font-size: .8em;

        &:hover {
          color: #000;
          font-weight: 600;
        }
      }
    }
  }

  @media all and (max-width:${vars.mobileM}) {
    .form-title {
      text-align: center;
    }

    .form-inputs {
      .layout-forms-input{
        font-size: 120%;
      }

      .layout-button {
        width: 5em;

        .button {
          padding: .95em;
          margin: 0 auto;
          background-color: #fff;

          &:hover {
            background-color: #fff;
          }

          .button-content {
            display: none;
          }

          .button-icon-before {
            margin: 0;
          }
        }
      }
    }

    .button-wrapper {
      display: none;
    }
  }
`;